module.exports = __webpack_public_path__ + "04_short_gray.a3c3f985.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_short_gray.png
// module id = mZV2
// module chunks = 0